import { render, staticRenderFns } from "./OrganisationProfileLogo.vue?vue&type=template&id=97b7202c&scoped=true&"
import script from "./OrganisationProfileLogo.vue?vue&type=script&lang=js&"
export * from "./OrganisationProfileLogo.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationProfileLogo.vue?vue&type=style&index=0&id=97b7202c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7202c",
  null
  
)

export default component.exports